import SectionHeading from '@/components/base/SectionHeading';
import SubscribeForm from '@/pages/home/components/SubscribeForm';

const principles = [
  { icon: 'ri-file-list-3-line', title: '先看来源', desc: '官方通报与可核验材料优先，匿名爆料只作为线索起点。' },
  { icon: 'ri-refresh-line', title: '保留反转', desc: '被修正的节点不删除，标注变化过程，让时间线保持真实。' },
  { icon: 'ri-scales-3-line', title: '双方呈现', desc: '只要当事人愿意回应，我们尽量给出完整的立场与说明。' },
  { icon: 'ri-time-line', title: '持续追踪', desc: '事件结束前不写“剧终”，新进展出现就补充新的节点。' },
];

const voices = [
  {
    text: '以前刷到爆料只看到最炸的那一段，来这里才第一次看到完整时间线，反转几次一目了然。',
    name: '读者 阿桐',
    role: '关注直播带货',
  },
  {
    text: '被辟谣专区救了。差点信了一个截图，结果在核实记录里看到完整解释。',
    name: '读者 小渔',
    role: '内容从业者',
  },
];

const AboutSection = () => (
  <section id="about" className="scroll-mt-24 bg-background-50">
    <div className="layout-shell py-12 md:py-16">
      <SectionHeading
        eyebrow="About Us"
        title="关于瓜田追踪"
        desc="一个把“后续”当成正事的内容团队，试图让热点讨论多一点耐心，少一点情绪。"
      />

      <div className="mt-8 grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
        <div className="lg:col-span-7">
          <div className="max-w-2xl space-y-4 text-[15px] leading-relaxed text-foreground-700">
            <p>
              瓜田追踪聚焦内容生态里那些“更新了但没有结局”的事件：账号解约、带货争议、内容版权、公益账目与剧情炒作。
              我们相信，爆料的价值不在于情绪的高潮，而在于它最终有没有被解释清楚。
            </p>
            <p>
              网站以时间线为核心结构。每个事件都有起始节点、反转节点与回应节点，并用“待核实 / 持续追踪 / 已澄清 / 事件反转”四种状态提醒读者当前的信息成熟度。
              我们也会主动更新已经说错的判断，而不是把它藏起来。
            </p>
            <p>
              我们不是裁判，也不替任何人下结论。这里的内容用于了解事件脉络，最终事实请以官方通报与当事人正式声明为准。
            </p>
          </div>

          <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
            {principles.map((p) => (
              <div key={p.title} className="rounded-lg border border-background-300/70 bg-background-100 p-4">
                <div className="flex items-center gap-2.5">
                  <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                    <i className={p.icon} aria-hidden="true" />
                  </span>
                  <h3 className="font-heading text-base font-bold text-foreground-950">{p.title}</h3>
                </div>
                <p className="mt-2.5 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
              </div>
            ))}
          </div>

          <div className="mt-8">
            <h3 className="font-heading text-base font-bold text-foreground-950">读者怎么说</h3>
            <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {voices.map((v) => (
                <blockquote key={v.name} className="rounded-lg border border-background-300/70 bg-accent-50 p-4">
                  <p className="text-sm leading-relaxed text-foreground-700">“{v.text}”</p>
                  <footer className="mt-3 flex items-center gap-2 text-xs text-foreground-500">
                    <span className="flex h-7 w-7 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                      <i className="ri-user-3-line" aria-hidden="true" />
                    </span>
                    <span className="font-medium text-foreground-800">{v.name}</span>
                    <span>· {v.role}</span>
                  </footer>
                </blockquote>
              ))}
            </div>
          </div>
        </div>

        <div className="lg:col-span-5">
          <div className="rounded-lg border border-background-300/70 bg-background-100 p-5">
            <h3 className="font-heading text-lg font-bold text-foreground-950">联系我们</h3>
            <ul className="mt-4 space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <span className="flex h-9 w-9 flex-none items-center justify-center rounded-md bg-background-50 text-primary-700">
                  <i className="ri-mail-line" aria-hidden="true" />
                </span>
                <span>
                  <span className="block text-xs text-foreground-500">邮箱</span>
                  <a href="mailto:hello@guatian-zhui.example" className="font-medium text-foreground-900 transition-colors hover:text-primary-700">
                    hello@guatian-zhui.example
                  </a>
                </span>
              </li>
              <li className="flex items-start gap-3">
                <span className="flex h-9 w-9 flex-none items-center justify-center rounded-md bg-background-50 text-primary-700">
                  <i className="ri-chat-forward-line" aria-hidden="true" />
                </span>
                <span>
                  <span className="block text-xs text-foreground-500">回应与更正</span>
                  <span className="font-medium text-foreground-900">在表单中备注“当事人回应”，我们会优先处理</span>
                </span>
              </li>
              <li className="flex items-start gap-3">
                <span className="flex h-9 w-9 flex-none items-center justify-center rounded-md bg-background-50 text-primary-700">
                  <i className="ri-map-pin-line" aria-hidden="true" />
                </span>
                <span>
                  <span className="block text-xs text-foreground-500">内容范围</span>
                  <span className="font-medium text-foreground-900">全网公开内容生态，不针对特定平台</span>
                </span>
              </li>
            </ul>
          </div>

          <div className="mt-5">
            <SubscribeForm />
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default AboutSection;